
export default {
  props: {
    width: {
      type: [Number, String],
      required: false,
    },
    notificationName: {
      type: String,
      required: true,
    },
    data: {
      type: [Object, Array],
      required: false,
    },
    className: {
      type: String,
      required: false,
    },
    eventName: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    onDialogCardToggled() {
      this.dialog = !this.dialog
    },
    onPricingCardToggled() {
      this.$emit(this.eventName)
    },
    openDialog(e) {
      const tagName = e.target.tagName.toLowerCase()
      if (tagName === 'a') {
        this.dialog = false
        return
      }
      this.dialog = true
    },
  },
}
